import React, { useState } from 'react';
import { Input, Typography, Space } from 'antd';
import { SolutionOutlined } from '@ant-design/icons';
import { Field } from '@guuru/react-forms';

const { TextArea } = Input;
const { Text, Link } = Typography;

interface AboutProps {
  partnerId: string;
  name: string;
  bio: string | null;
  loading: boolean;
}

const About = function ({
  partnerId,
  name,
  bio,
  loading,
}: AboutProps) {
  const [editMode, setEditMode] = useState(false);
  return (
    <Field
      name="bio"
      label={(
        <Space>
          <SolutionOutlined />
          <Text>Bio</Text>
        </Space>
        )}
      rules={[
        {
          required: true,
          message: 'Please input your Bio',
        },
      ]}
      extra={!bio ? (
        <>
          <Text type="secondary">Don&apos;t know what to write? Find some inspiration </Text>
          <Link
            target="_blank"
            href={`${process.env.PAGES_URL}/${partnerId}/articles/manage-profile`}
          > here.
          </Link>
        </>
      ) : undefined}
    >
      <TextArea
        autoSize
        disabled={loading}
        maxLength={250}
        autoFocus={editMode}
        showCount={editMode}
        placeholder={`Tell us what makes you a good ${name} Guuru?`}
        onFocus={() => setEditMode(true)}
        onBlur={() => setEditMode(false)}
      />
    </Field>
  );
};

export default About;
